import { useState } from 'react';
import { getBrowserType } from 'helpers';
import SchoolAdminInvitedAfterMeetingAboutUs from './SchoolAdminInvitedAfterMeetingAboutUs';
import TeacherInvitedAfterMeetingInstallExtension from '../TeacherInvitedAfterMeeting/TeacherInvitedAfterMeetingInstallExtension';
import StudentInvitedReadingAnalysisPin from '../StudentInvited/StudentInvitedReadingAnalysisPin';

const EXTENSION_URLS = {
  chrome: process.env.REACT_APP_CHROME_EXTENSION_URL,
  firefox: process.env.REACT_APP_FIREFOX_EXTENSION_URL,
  safari: process.env.REACT_APP_SAFARI_EXTENSION_URL,
  edge: process.env.REACT_APP_EDGE_EXTENSION_URL,
};

function SchoolAdminInvitedAfterMeeting({ onComplete, ...props }) {
  const [step, setStep] = useState(0);

  function openExtensionUrl() {
    const b = getBrowserType();
    const url =
      (b.isChrome && EXTENSION_URLS.chrome) ||
      (b.isFirefox && EXTENSION_URLS.firefox) ||
      (b.isSafari && EXTENSION_URLS.safari) ||
      (b.isEdge && EXTENSION_URLS.edge);
    if (url) window.open(url, '_blank');
  }

  if (step === 0) {
    return (
      <SchoolAdminInvitedAfterMeetingAboutUs
        {...props}
        onContinue={() => setStep(1)}
      />
    );
  }

  if (step === 1) {
    return (
      <TeacherInvitedAfterMeetingInstallExtension
        onInstall={() => {
          openExtensionUrl();
          setStep(2);
        }}
        onSkip={onComplete}
      />
    );
  }

  return (
    <StudentInvitedReadingAnalysisPin
      onContinue={async () => {
        await onComplete();
      }}
    />
  );
}

export default SchoolAdminInvitedAfterMeeting;
